import styled from 'styled-components';

export const TravelData = styled.p`
  font-size: 12px;
  margin-bottom: 4px;
`;
